import { render } from "./ExternalTools.vue?vue&type=template&id=2d9c3e00"
import script from "./ExternalTools.vue?vue&type=script&lang=js"
export * from "./ExternalTools.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__